
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/satilik-villa",
      function () {
        return require("private-next-pages/satilik-villa.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/satilik-villa"])
      });
    }
  